import axios from 'axios';
import * as Sentry from '@sentry/react';

const API_BASE =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api/public';

const apiClient = axios.create({
  baseURL: API_BASE,
});

// Normalize paginated ({count, results}) and plain array responses to arrays.
const toList = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return Array.isArray(data.results) ? data.results : [];
};

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (process.env.REACT_APP_SENTRY_DSN) {
      Sentry.captureException(err, {
        extra: {
          url: err.config?.url,
          method: err.config?.method,
          status: err.response?.status,
        },
      });
    }
    return Promise.reject(err);
  },
);

export const exhibitionService = {
  getAll: (params = {}) =>
    apiClient.get('/exhibitions/', { params }).then((res) => toList(res.data)),

  getById: (id) =>
    apiClient.get(`/exhibitions/${id}/`).then((res) => res.data),

  search: (query) =>
    apiClient
      .get('/exhibitions/', { params: { search: query } })
      .then((res) => toList(res.data)),

  getByStatus: (status) =>
    apiClient
      .get('/exhibitions/', { params: { status } })
      .then((res) => toList(res.data)),

  getByCity: (city) =>
    apiClient
      .get('/exhibitions/', { params: { city } })
      .then((res) => toList(res.data)),

  getByArtist: (artist) =>
    apiClient
      .get('/exhibitions/', { params: { artist } })
      .then((res) => toList(res.data)),

  getFiltered: (filters) =>
    apiClient.get('/exhibitions/', { params: filters }).then((res) => toList(res.data)),
};

// Preferred alias — components should migrate to eventService over time.
// exhibitionService remains the underlying implementation.
export const eventService = exhibitionService;

export const artistService = {
  getAll: () => apiClient.get('/artists/').then((res) => toList(res.data)),
  getById: (id) => apiClient.get(`/artists/${id}/`).then((res) => res.data),
};

export const venueService = {
  getAll: () => apiClient.get('/venues/').then((res) => toList(res.data)),
  getById: (id) => apiClient.get(`/venues/${id}/`).then((res) => res.data),
};
